import React, { useState } from 'react';
import { brandsMock } from '../../Data/Dummydata';
import { Search } from 'lucide-react';

export default function BrandMarginView() {
  const [searchQuery, setSearchQuery] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');

  // Filter and sort logic
  const filteredBrands = brandsMock
    .filter((brand) => brand.name.toLowerCase().includes(searchQuery.toLowerCase()))
    .sort((a, b) =>
      sortOrder === 'asc'
        ? a.marginPercentage - b.marginPercentage
        : b.marginPercentage - a.marginPercentage,
    );

  return (
    <div className="max-w-6xl mx-auto">
      <h2 className="text-2xl font-bold mb-4 ml-3">Seller: Brand Margins</h2>

      {/* Search + Sort Controls */}
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-8">
        {/* Search */}
        <div className="relative w-full sm:w-72">
          <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search by brand..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-10 pr-4 py-2 rounded-lg border border-gray-300 text-sm focus:outline-none focus:ring-2 border-color w-full"
          />
        </div>

        {/* Sort */}
        <div className="w-full sm:w-auto">
          <select
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
            className="border border-gray-300 rounded-lg py-2 px-4 text-sm focus:outline-none focus:ring-2 border-color"
          >
            <option value="asc">Filter</option>

            <option value="asc">Margin: Low → High</option>
            <option value="desc">Margin: High → Low</option>
          </select>
        </div>
      </div>

      {/* Brand Cards */}
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {filteredBrands.length > 0 ? (
          filteredBrands.map((brand) => (
            <div
              key={brand.id}
              className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200"
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-base font-medium ">{brand.name}</h3>
              </div>

              <div className="text-base font-bold text-secondary">
                {brand.marginPercentage}%<span className="text-sm text-gray-500"> Margin</span>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center col-span-full text-gray-500">
            No brands match your search.
          </div>
        )}
      </div>
    </div>
  );
}
